<user-preferences-mobile *ngIf="isMobile"></user-preferences-mobile>
<user-preferences-desktop *ngIf="!isMobile"></user-preferences-desktop>